/** Client-safe env accessors — never export secret values. */
export interface EnvStatus {
  hasTokenMintUrl: boolean;
  hasAgentsUrl: boolean;
  hasSupabaseUrl: boolean;
  hasLandingEditorApi: boolean;
}

export function getEnvStatus(): EnvStatus {
  const agentsUrl = import.meta.env.VITE_LANDI_AGENTS_URL ?? import.meta.env.VITE_LANDING_EDITOR_API_ORIGIN ?? '';
  return {
    hasTokenMintUrl: Boolean(import.meta.env.VITE_TOKEN_MINT_URL),
    hasAgentsUrl: Boolean(import.meta.env.VITE_LANDI_AGENTS_URL),
    hasSupabaseUrl: Boolean(import.meta.env.VITE_SUPABASE_URL),
    hasLandingEditorApi: Boolean(agentsUrl),
  };
}
